import React from 'react';
const comparisons = [{
  sin: 'Crisis que se repiten sin entender por qué',
  con: 'Protocolo de prevención desde semana 1'
}, {
  sin: 'Frases que alimentan la ansiedad sin saberlo',
  con: 'Guión exacto de lo que funciona'
}, {
  sin: 'Noches sin dormir esperando la próxima crisis',
  con: 'Sistema nocturno que enseña a dormir solo'
}, {
  sin: 'El colegio no sabe cómo ayudarlo',
  con: 'Manual escolar en manos de la maestra'
}, {
  sin: 'Culpa constante sin saber qué cambiar',
  con: '10 errores identificados y corregidos'
}, {
  sin: 'Lo rescatás porque no sabés qué más hacer',
  con: 'Diferencia clara contener vs rescatar aplicada'
}, {
  sin: 'Cada crisis te encuentra improvisando',
  con: 'Protocolo de emergencia listo y en la pared'
}, {
  sin: 'Seguís igual en 6 meses',
  con: 'Hijo emocionalmente más fuerte en 60 días'
}];
export const CostComparison = () => {
  return <section className="relative w-full bg-[#F8F6FF] py-12 sm:py-16 md:py-20" data-id="element-23">
      <div className="mx-auto max-w-[720px] px-5" data-id="element-24">
        <div className="mb-12 text-center" data-id="element-25">
          <span className="mb-4 inline-block rounded-full bg-[#D4A017] px-3 py-1 text-xs font-bold uppercase tracking-wide text-[#1A0A2E]" data-id="element-26">
            LA DIFERENCIA
          </span>
          <h2 className="font-heading text-3xl font-bold text-[#1A0A2E] sm:text-4xl md:text-5xl" data-id="element-27">
            ¿Cuánto te cuesta
            <br data-id="element-28" />
            <span className="text-violet-gradient" data-id="element-29">no tenerlo?</span>
          </h2>
        </div>

        <div className="overflow-hidden rounded-[24px] border border-[#A855F7]/30 bg-white shadow-card-hover" data-id="element-30">
          <div className="grid grid-cols-2 border-b border-[#A855F7]/20" data-id="element-31">
            <div className="flex items-center justify-center bg-[#FFE4E4] p-4 sm:p-6" data-id="element-32">
              <span className="text-sm font-bold text-[#DC2626] sm:text-base" data-id="element-33">
                ❌ SIN EL KIT
              </span>
            </div>
            <div className="flex items-center justify-center bg-[#ECFDF5] p-4 sm:p-6" data-id="element-34">
              <span className="text-sm font-bold text-[#059669] sm:text-base" data-id="element-35">
                ✅ CON EL KIT
              </span>
            </div>
          </div>

          <div className="flex flex-col" data-id="element-36">
            {comparisons.map((item, i) => <div key={i} className={`grid grid-cols-2 border-b border-[#A855F7]/10 last:border-0 ${i % 2 === 0 ? 'bg-white' : 'bg-[#F8F6FF]'}`} data-id="element-37">
                <div className="flex items-start gap-2 p-4 text-[13px] font-medium text-[#4B3B6B] sm:p-6 sm:text-[15px]" data-id="element-38">
                  <span className="mt-1 text-[#DC2626]" data-id="element-39">•</span>
                  <span data-id="element-40">{item.sin}</span>
                </div>
                <div className="flex items-start gap-2 border-l border-[#A855F7]/10 p-4 text-[13px] font-bold text-[#1A0A2E] sm:p-6 sm:text-[15px]" data-id="element-41">
                  <span className="mt-1 text-[#6B21A8]" data-id="element-42">✓</span>
                  <span data-id="element-43">{item.con}</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};